import React from 'react';
import { Container, Form, Button, FormControl, FormGroup, Col, Alert, Row } from 'react-bootstrap';
import ContentBlockSmall from '../Components/ContentBlockSmall';
import RegsterService from '../Api/RegsterService';

class Registration extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            pageName: 'Registracija',
            email: '',
            password: '',
            passwordConfirmation: '',
            firsName: '',
            lastName: '',
            phone: '',
            alertText: '',
        }
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleInputChange(event) {
        this.setState({alertText: ''});
        
        const target = event.target;
        const value = target.value;
        const name = target.name;
        this.setState({
            [name]: value
        });

        if (name === 'passwordConfirmation') {
            if (value !== this.state.password) {
                console.log('Slaptažodžiai nesutampa: confirm = ' + value + ' pass = ' + this.state.password); 
                this.setState({alertText: 'Slaptažodžiai nesutampa', passwordConfirmation: value === '' ? '': 'Nesutampa su slaptažodžiu'});
                event.preventDefault();
            } else {
                this.setState({passwordConfirmation: ''});
            }
        }
    }

    handleSubmit(event) {
        event.preventDefault();
        var userData={};
        userData['email'] = this.state.email;
        userData['password'] = this.state.password;
        userData['firstName'] = this.state.firsName;
        userData['lastName'] = this.state.lastName;
        userData['phone'] = this.state.phone;

        console.log(userData);
        
        RegsterService.registerUser(userData)
            .then((response) => {
                if (response.status === 201 || response.status === 200) {
                    this.setState({alertText: 'Registracija sėkminga'});
                    setTimeout(() => {
                        window.location = '/login';
                    }, 3000);
                } else {
                    if (response.status === 409) {
                        this.setState({alertText: 'Toks vartotojas jau egzistuoja'});
                    } else {
                        this.setState({alertText: 'Nepavyko registruoti, bandykite dar kartą'});
                    }
                }
            })
            .catch((error) => {
                console.log(error);
                this.setState({alertText: 'Nepavyko registruoti, bandykite dar kartą'});
            });
    }

    componentDidMount() {
        document.title = this.state.pageName;
    }

    componentDidUpdate() {
        document.title = this.state.pageName;
    }

    componentWillUnmount() {
        this.setState({pageName: 'Registracija'});  
    }

    render() {

        const pageStyle = {
            backgroundImage: "url(/kursai-page-background.png)",
            height: '100vh',
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat',
        };


        return (
            <Container fluid style={pageStyle}>
                <Container style={{paddingTop:'10vh'}}>
                    <h1 className='page-title'>{this.state.pageName}</h1>
                    <ContentBlockSmall>
                        <Alert variant='danger' show={this.state.alertText !== ''}>{this.state.alertText}</Alert>
                        <Form>
                            <FormGroup className="mb-3" as={Col}>
                                <Form.Text className="text-muted">El. paštas</Form.Text>
                                <FormControl type="email" placeholder="Įveskite el. paštą" name="email" onChange={this.handleInputChange} />
                            </FormGroup>
                            <FormGroup className="mb-3" as={Col}>
                                <Form.Text className="text-muted">Slaptažodis</Form.Text>
                                <FormControl type="password" placeholder="Įveskite slaptažodį" name="password" onChange={this.handleInputChange} />
                            </FormGroup>
                            <FormGroup className="mb-3" as={Col}>
                                <Form.Text className="text-muted">Pakartokite slaptažodį</Form.Text>
                                <FormControl type="password" placeholder="Įveskite slaptažodį"  name="passwordConfirmation" onChange={this.handleInputChange}/>
                            </FormGroup>
                            <FormGroup className="mb-3" as={Col}>
                                <Form.Text className="text-muted">Vardas</Form.Text>
                                <FormControl type="text" placeholder="Įveskite vardą"  name="firsName" onChange={this.handleInputChange}/>
                            </FormGroup>
                            <FormGroup className="mb-3" as={Col}>
                                <Form.Text className="text-muted">Pavardė</Form.Text>
                                <FormControl type="text" placeholder="Įveskite pavardę"  name="lastName" onChange={this.handleInputChange}/>
                            </FormGroup>
                            <FormGroup className="mb-3" as={Col}>
                                <Form.Text className="text-muted">Mob. Tel.</Form.Text>
                                <FormControl type="text" placeholder="Įveskite telefono numerį"  name="phone" onChange={this.handleInputChange}/>
                            </FormGroup>
                            <Button 
                                variant="outline-light" 
                                onClick={this.handleSubmit} 
                                style={{width: '100%'}} 
                                size="lg"
                                //disabled={this.state.alertText !== '' || this.state.password === '' || this.state.email === ''}
                                 >
                                Registruotis
                            </Button>
                        </Form>
                    </ContentBlockSmall>
                </Container>
            </Container>
        );
    }

}

export default Registration;